import { useNetworkHealth } from '../hooks/useNetworkHealth';

interface Props {
  wsConnected: boolean;
}

export function TvNetworkHud({ wsConnected }: Props) {
  const { pingMs, bandwidth, connectionType, isOnline } = useNetworkHealth();

  const pingColor =
    pingMs === null ? 'text-zinc-500' :
    pingMs < 100    ? 'text-green-400' :
    pingMs < 300    ? 'text-yellow-400' :
                      'text-red-500';

  return (
    <div className="fixed bottom-2 right-2 z-[9999] pointer-events-none rounded bg-black/80 backdrop-blur px-3 py-2 border border-zinc-800 font-mono text-[10px] text-green-400 leading-tight flex flex-col gap-1">
      <span>
        STATUS:{' '}
        {isOnline
          ? 'ONLINE'
          : <span className="text-red-500">OFFLINE</span>}
      </span>
      <span className={pingColor}>
        PING: {pingMs !== null ? `${pingMs}ms` : '---'}
      </span>
      <span>
        DOWNLINK: {bandwidth !== null ? `${bandwidth}Mbps` : '---'}
      </span>
      <span>
        TIPO: {connectionType?.toUpperCase() ?? '---'}
      </span>
      <span>
        WS:{' '}
        {wsConnected
          ? 'CONECTADO'
          : <span className="text-red-500">OFFLINE</span>}
      </span>
    </div>
  );
}
